import React, {Fragment} from "react";

const SmallTitleLIne = (props) => {
    return (
        <Fragment>
            <h4 className="text-orange-900">{props.titulo}</h4>
            <hr className="mb-3 mt-1 border-orange-900"/>
        </Fragment>
    );
}

export default SmallTitleLIne;
